import React from "react";

const ArticlesPage = (props) => {
  return (
    <div>
      <div
        id="fws_5e7bf422b186b"
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="4%"
        data-bottom-percent="2%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row top-level full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{
          paddingTop: "calc(100vw * 0.04)",
          paddingBottom: "calc(100vw * 0.02)"
        }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-12 wpb_column column_container vc_column_container col padding-3-percent"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="right"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div
                  id="fws_5e7bf422b26bc"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "2%" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-1/5 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper" />
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-3/5 wpb_column column_container vc_column_container col child_column centered-text no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <h1
                            style={{ color: "#05bff7", textAlign: "center" }}
                            className="vc_custom_heading"
                          >
                            Saved Articles
                          </h1>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-1/5 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="fws_5e7bf422b3e39"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "3%" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-1/5 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper" />
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-3/5 wpb_column column_container vc_column_container col child_column centered-text no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <h3>
                                Your Evernote saved articles in PRISM, email
                                articles to your contacts based on the PRISM
                                categories you&#8217;ve assigned them.
                              </h3>
                              <p>
                                <span style={{ color: "#a3a3a3" }}>
                                  <em>
                                    Tip: You can only change article categories
                                    in Evernote. So, make sure you use the same
                                    tags in Evernote as the categories you use
                                    in PRISM.
                                  </em>
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-1/5 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="fws_5e7bf422b528c"
        data-column-margin="default"
        data-midnight="dark"
        data-top-percent="1%"
        data-bottom-percent="7%"
        data-bg-mobile-hidden=""
        className="wpb_row vc_row-fluid vc_row full-width-section  vc_row-o-equal-height vc_row-flex  vc_row-o-content-top standard_section "
        style={{
          paddingTop: "calc(100vw * 0.01)",
          paddingBottom: "calc(100vw * 0.07)"
        }}
      >
        <div
          className="row-bg-wrap"
          data-bg-animation="none"
          data-bg-overlay="false"
        >
          <div className="inner-wrap">
            <div className="row-bg" />
          </div>
          <div className="row-bg-overlay" />
        </div>
        <div className="col span_12 dark left">
          <div
            className="vc_col-sm-3 wpb_column column_container vc_column_container col no-extra-padding"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="right"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div
                  id="fws_5e7bf422b5b2c"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 vc_hidden-lg wpb_column column_container vc_column_container col child_column centered-text padding-1-percent"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-normal iconsmind-Evernote extra-color-gradient-1" />
                                Sync Evernote
                                <br />
                                <span style={{ fontSize: "small" }}>
                                  last synced: mm/dd/yyyy
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="fws_5e7bf422b64fb"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-12 vc_hidden-md vc_hidden-sm vc_hidden-xs wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-normal iconsmind-Evernote extra-color-gradient-1" />
                                Sync Evernote
                                <br />
                                <span style={{ fontSize: "small" }}>
                                  last synced: mm/dd/yyyy
                                </span>
                              </p>
                            </div>
                          </div>

                          <div
                            className="divider-wrap"
                            data-alignment="default"
                          >
                            <div
                              style={{
                                marginTop: "12px",
                                width: "20%px",
                                height: "1px",
                                marginBottom: "12px"
                              }}
                              data-width="20%"
                              data-animate=""
                              data-animation-delay=""
                              data-color="default"
                              className="divider-small-border"
                            />
                          </div>
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-file-text extra-color-3" />
                                Saved Articles ####
                              </p>
                            </div>
                          </div>

                          <div
                            className="divider-wrap"
                            data-alignment="default"
                          >
                            <div
                              style={{
                                marginTop: "12px",
                                width: "20%px",
                                height: "1px",
                                marginBottom: "12px"
                              }}
                              data-width="20%"
                              data-animate=""
                              data-animation-delay=""
                              data-color="default"
                              className="divider-small-border"
                            />
                          </div>
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                # Articles by Category
                                <br />
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media #
                                <i className="icon-tiny fa fa-envelope-o extra-color-1" />
                                <br />
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Co-Workers #<br />
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Family #<br />
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Friends #<br />
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media #<br />
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Co-Workers #<br />
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Family #<br />
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Friends #
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="vc_col-sm-9 wpb_column column_container vc_column_container col no-extra-padding"
            data-t-w-inherits="default"
            data-border-radius="none"
            data-shadow="none"
            data-border-animation=""
            data-border-animation-delay=""
            data-border-width="none"
            data-border-style="solid"
            data-border-color=""
            data-bg-cover=""
            data-padding-pos="all"
            data-has-bg-color="false"
            data-bg-color=""
            data-bg-opacity="1"
            data-hover-bg=""
            data-hover-bg-opacity="1"
            data-animation=""
            data-delay="0"
          >
            <div className="vc_column-inner">
              <div className="column-bg-overlay-wrap" data-bg-animation="none">
                <div className="column-bg-overlay" />
              </div>
              <div className="wpb_wrapper">
                <div className="wpb_text_column wpb_content_element ">
                  <div className="wpb_wrapper">
                    <p>
                      <i className="icon-tiny fa fa-square-o extra-color-3" />
                      <i className="icon-tiny fa fa-envelope-o extra-color-3" />
                      <i className="icon-tiny fa fa-trash-o extra-color-3" />
                    </p>
                  </div>
                </div>

                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422b8ddc"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422bb75d"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422bdd6a"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422bf8fc"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422c058c"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422c1224"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422c1ee4"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422c2b74"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422c381f"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div
                  id="fws_5e7bf422c44b7"
                  data-midnight=""
                  data-column-margin="default"
                  data-bg-mobile-hidden=""
                  className="wpb_row vc_row-fluid vc_row inner_row standard_section    "
                  style={{ paddingTop: "0px", paddingBottom: "0px" }}
                >
                  <div className="row-bg-wrap">
                    <div className="row-bg   " />
                  </div>
                  <div className="col span_12  left">
                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div
                            className="nectar-fancy-ul"
                            data-list-icon="icon-check-empty"
                            data-animation="false"
                            data-animation-delay="0"
                            data-color="extra-color-1"
                            data-spacing="default"
                            data-alignment="left"
                          >
                            <ul>
                              <li>
                                <strong>Article Name</strong>
                                <br />
                                <a href="#">
                                  http:/www.articlesource.com/article
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="vc_col-sm-6 wpb_column column_container vc_column_container col child_column no-extra-padding"
                      data-t-w-inherits="default"
                      data-shadow="none"
                      data-border-radius="none"
                      data-border-animation=""
                      data-border-animation-delay=""
                      data-border-width="none"
                      data-border-style="solid"
                      data-border-color=""
                      data-bg-cover=""
                      data-padding-pos="all"
                      data-has-bg-color="false"
                      data-bg-color=""
                      data-bg-opacity="1"
                      data-hover-bg=""
                      data-hover-bg-opacity="1"
                      data-animation=""
                      data-delay="0"
                    >
                      <div className="vc_column-inner">
                        <div
                          className="column-bg-overlay-wrap"
                          data-bg-animation="none"
                        >
                          <div className="column-bg-overlay" />
                        </div>
                        <div className="wpb_wrapper">
                          <div className="wpb_text_column wpb_content_element ">
                            <div className="wpb_wrapper">
                              <p>
                                <i className="icon-tiny fa fa-tag extra-color-3" />
                                Digital Media, Family, Friends, Co-wo&#8230;.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="divider-wrap" data-alignment="default">
                  <div
                    style={{
                      marginTop: "12px",
                      height: "1px",
                      marginBottom: "12px"
                    }}
                    data-width="100%"
                    data-animate=""
                    data-animation-delay=""
                    data-color="default"
                    className="divider-border"
                  />
                </div>
                <div className="wpb_text_column wpb_content_element ">
                  <div className="wpb_wrapper">
                    <p style={{ textAlign: "center" }}>
                      <span style={{ color: "#a3a3a3", fontSize: "small" }}>
                        1-10 of about 50
                      </span>
                      <i className="icon-tiny fa fa-chevron-left extra-color-1" />
                      <i className="icon-tiny fa fa-chevron-right extra-color-1" />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArticlesPage;
